import axios from '@/components/plugins/axios'
const url = process.env.VUE_APP_API_URL

class OpeningHour {
  update (data) {
    return axios.put(url + '/restaurant-manager/openingHoursNew', data)
  }
}
export default new OpeningHour()
